import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';
import { SextforceAutoRepost } from './useSextforceAutoRepost';
import { SextforceAutoRepostLog } from './useSextforceAutoRepostLogs';

const useSextforceAutoRepostLogsPaginated = (autoRepost: SextforceAutoRepost, limit: number, offset: number) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const axios = useAxios();
    const dialog = useDialog();
    const params = useParams();

    // Fetch online users count vs. total sales report
    const fetchData = async (autoRepost: SextforceAutoRepost): Promise<{ list: SextforceAutoRepostLog[]; total: number }> => {
        if (!userContext.jwtToken || !settingsContext.apiKey) {
            return { list: [], total: 0 };
        }

        const query: string = `${settingsContext.routes.autoRepost.base}${params.userId}/${autoRepost._id}/logsPaginated`;

        const data = await axios
            .get(query, {
                params: {
                    limit: limit,
                    offset: offset,
                },
            })
            .then(async response => response.data)
            .catch(error => {
                handleHttpError(error, dialog);

                return { list: [], total: 0 };
            });

        return data;
    };

    return useQuery(
        ['autoRepostLogsPaginated', params.userId, userContext.jwtToken, autoRepost._id, limit, offset],
        () => {
            return fetchData(autoRepost);
        },
        {
            refetchOnWindowFocus: false,
            enabled: userContext.jwtToken && params.userId && settingsContext.apiKey ? true : false,
        },
    );
};

export default useSextforceAutoRepostLogsPaginated;
